/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { getContractList_V2Async } from './DataActionExtension.g';
import { IContractListEntity_V2 } from './DataServiceEntities.g';

/**
 * GetContractListV2 Input Action
 */

export class GetContractListV2Input implements Msdyn365.IActionInput {
    public constructor() {}

    public getCacheKey = () => 'ContractListV2';
    public getCacheObjectType = () => 'ContractListResponseV2';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

const createContractListInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetContractListV2Input();
};

async function action(input: GetContractListV2Input, ctx: Msdyn365.IActionContext): Promise<IContractListEntity_V2[]> {
    const response = await getContractList_V2Async({ callerContext: ctx });
    return response;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IContractListEntity_V2[]>>action,
    id: 'GetContractListV2',
    input: createContractListInput
});
